import * as React from "react"
import { useEffect } from "react"
import { Box, Grid, Typography } from "@mui/material"
import { useSignal } from "@preact/signals-react"
import { SwitchSeeker } from "@ui-seeker/core"
import { getSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"
import { formData } from "../../@signals"


// Availability lives on DIPI_CUSTOMER_BRAND, one row per (customer, brand), so
// each selected customer gets its own pair of switches. A customer with no
// stored entry defaults to both flags ON: that is what makes a brand created
// here visible in site navigations and banners right away.
const DEFAULT_AVAILABILITY = { banners: true, siteNavigations: true }


export default function AdminBrandsCustomerAvailability() {
    const options = useSignal([])
    const customerIDs = formData.value?.customerIDs || []
    const availability = formData.value?.customerAvailability || []

    useEffect(() => {
        getSubmit(`${BACKEND_APIS.BRANDS}/crud/customer`)
            .then(res => {
                options.value = res || []
            })
            .catch(err => {
                console.error('Failed to fetch customers:', err)
                options.value = []
            })
    }, [])

    // Keep the payload in sync with the multi-select: newly added customers get
    // the default, removed ones are dropped so no stale customer is sent.
    useEffect(() => {
        const current = formData.value?.customerAvailability || []
        const next = (formData.value?.customerIDs || []).map(customerID => {
            const entry = current.find(item => String(item.customerID) === String(customerID))
            return entry || { customerID, ...DEFAULT_AVAILABILITY }
        })

        if (JSON.stringify(next) !== JSON.stringify(current))
            formData.value = { ...formData.value, customerAvailability: next }
    }, [JSON.stringify(customerIDs)])

    const handleChange = (customerID, field, value) => {
        formData.value = {
            ...formData.value,
            customerAvailability: (formData.value?.customerAvailability || []).map(entry =>
                String(entry.customerID) === String(customerID) ? { ...entry, [field]: value } : entry
            )
        }
    }

    if (!customerIDs.length)
        return null

    return <Box>
        <Typography variant="subtitle2" gutterBottom>Customer Availability</Typography>

        <Grid container spacing={1}>
            {customerIDs.map(customerID => {
                const entry = availability.find(item => String(item.customerID) === String(customerID)) || DEFAULT_AVAILABILITY
                const option = options.value.find(item => String(item.value) === String(customerID))

                return <Grid container item xs={12} spacing={1} key={customerID} alignItems="center">
                    <Grid item xs={4}>
                        <Typography variant="body2">{option?.label || customerID}</Typography>
                    </Grid>

                    <Grid item xs={4}>
                        <SwitchSeeker
                            label="Site Navigations"
                            checked={!!entry.siteNavigations}
                            onChange={e => handleChange(customerID, 'siteNavigations', e.target.checked)}
                        />
                    </Grid>

                    <Grid item xs={4}>
                        <SwitchSeeker
                            label="Banners"
                            checked={!!entry.banners}
                            onChange={e => handleChange(customerID, 'banners', e.target.checked)}
                        />
                    </Grid>
                </Grid>
            })}
        </Grid>
    </Box>
}
